// test1041
(1041 && 0);
